import React, { lazy } from 'react'
import Header from "./components/Header/Header"
import Nav from "./components/Nav/Nav"
import About from "./components/about/About"
import Experience from "./components/experience/Experience"
import Portfolio from "./components/Portfolio/Portfolio"
import Contact from "./components/contact/Contact"
import Footer from "./components/Footer/Footer"






const App = () => {
  return (
    <>
    <Header/>
    <Nav/>
    <Portfolio />
    <About/>
    <Experience />

    
    <Contact />
    <Footer />

    </>
  )
}

export default App